import FooterPartenerCommun from "../commun/FooterPartenerCommun";
import Header from "../commun/Header";

export default function Dashboard(){

    return(
        <div className="dashboard">
            <Header/>
            <div className="container">
            <h4 className="text-center mt-5  w-custom">
                Plenary Meeting, Madrid
                <br />
                15-17 November 2024
            </h4>
                <div className="row mt-3">
                    <div className="col col-12 p-3">
                        <div className="card-blue c-p" onClick={()=>{window.location.href = '/program'}}>
                            <h4>
                                Trilateral <br /> Commission agenda
                            </h4>
                        </div>
                    </div>
                    <div className="col col-12 p-3">
                        <div className="card-blue c-p" onClick={()=>{window.location.href = '/program_drf'}}>
                            <h4>
                                David Rockefellers<br />Fellows program
                            </h4>
                        </div>
                    </div>
                    <div className="col col-6 p-3">
                        <div className="card-blue c-p" onClick={()=>{window.location.href = '/list'}}>
                            <h4>
                                Participant <br />list
                            </h4>
                        </div>
                    </div>
                    <div className="col col-6 p-3">
                        <div className="card-blue c-p" onClick={()=>{window.location.href = '/speakers'}}>
                            <h4>
                                Speakers
                            </h4>
                        </div>
                    </div>
                    <div className="col col-6 p-3">
                        <div className="card-blue c-p" onClick={()=>{window.location.href = '/contact'}}>
                            <h4>
                                Contact
                            </h4>
                        </div>
                    </div>
                    <div className="col col-6 p-3">
                        <a href="./TRILATERAL-EU-2024-Partners-Programme.html" style={{textDecoration: 'none'}}>
                            <div className="card-blue c-p">
                                <h4 className="mt-custom">
                                    <span style={{color: 'white', textDecoration: 'none'}}>
                                        Partners
                                        program
                                    </span>
                                </h4>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <FooterPartenerCommun/>
        </div>
    )
}